import { render, staticRenderFns } from "./NotificationFire.vue?vue&type=template&id=6b272d94&scoped=true"
import script from "./NotificationFire.vue?vue&type=script&lang=js"
export * from "./NotificationFire.vue?vue&type=script&lang=js"
import style0 from "./NotificationFire.vue?vue&type=style&index=0&id=6b272d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b272d94",
  null
  
)

export default component.exports